import { render, staticRenderFns } from "./DeleteCourseModal.vue?vue&type=template&id=125af396&scoped=true&"
import script from "./DeleteCourseModal.vue?vue&type=script&lang=js&"
export * from "./DeleteCourseModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCourseModal.vue?vue&type=style&index=0&id=125af396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125af396",
  null
  
)

export default component.exports